<template>
  <BaseRouterLink v-bind="attrs"
                  v-on="$listeners"
                  :disabled="disabled"
                  :href="href">
    <div :style="containerStyle">
      <IconPrimary v-bind="iconStyle"/>
      <div :style="slotStyle">
        <slot />
      </div>
    </div>
  </BaseRouterLink>
</template>

<script>
  import BaseRouterLink from '@base/base-router-link'
  import IconPrimary from '@modules/icon/icon-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'RouterLinkBackPrimary',
    components: {
      BaseRouterLink,
      IconPrimary,
    },
    props: {
      disabled: { type: Boolean, required: false, default: false },
      href: { type: String, required: false, default: '#' },
      openInCurrentTab: { type: Boolean, required: false, default: true },
    },
    data: function () {
      return {
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '17px',
        },
        iconStyle: {
          content: 'arrow_back',
          display: 'block',
          fontSize: '18px',
        },
        slotStyle: {
          marginLeft: '6px',
        },
      };
    },
    created: function () {
      this.iconStyle = {
        ...this.iconStyle,
        color: this.color.dark3(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      attrs: function () {
        return {
          border: 'none',
          borderRadius: Layout.space.sm,
          borderWidth: 'none',
          cursor: { '': 'pointer', disabled: 'default' },
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.lg,
          padding: '4px 12px 4px 6px',
          textDecoration: 'none',
          backgroundColor: this.color.light1(0.5),
          color: this.color.dark3(),
          ...this.$attrs,
        };
      },
    },
  };
</script>
